import { useContext } from 'react';
import { CameraKitMasterContext } from '../contexts/CameraKitContext';
export const useCameraKit = () => {
    const state = useContext(CameraKitMasterContext);
    if (!state) {
        throw new Error('useCameraKit must be used inside of a CameraKitContext');
    }
    return state;
};
